const QUERY = "(prefers-color-scheme: dark)"

function applyTheme(isDark) {
  const scheme = isDark ? "dark" : "light"

  document.querySelectorAll("[data-theme-swap]").forEach((el) => {
    const href = el.getAttribute(`data-${scheme}`)
    if (href) el.setAttribute("href", href)
  })

  document.querySelectorAll("[data-theme-content]").forEach((el) => {
    const content = el.getAttribute(`data-${scheme}`)
    if (content) el.setAttribute("content", content)
  })
}

const mql = window.matchMedia(QUERY)
applyTheme(mql.matches)
mql.addEventListener("change", (e) => applyTheme(e.matches))
